import {keys} from 'ts-transformer-keys';
import {Condition} from '~/shared/src/utilities/condition';


type RequiredKeys<T> = { [K in keyof T]-? : {} extends Pick<T, K> ? never : K }[keyof T];
type RequiredOf<T> = Pick<T, RequiredKeys<T>>;


export type PanelConfig = {
    id : number;
    key : string;
    name : string;

    config? : JSON;
    order? : number;
    rootItemKey? : string;
    rootItemType? : string;
    schema? : Schema;

    isBlocking: boolean;
    openAsPanel: boolean;
    openAsPopup: boolean;
    condition? : Condition;
};
export const panelConfigProps = keys<PanelConfig>();
export const requiredPanelConfigProps = keys<RequiredOf<PanelConfig>>();
